import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Showcase,
  Header,
  SectionTitle,
  Intro,
} from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        slug={data.slug + '/develop/'}
        site={data.site}
        state="develop"
        title={data.title}
      >
        <Intro>
          <p>
            The account card presents the user with actions and information
            associated with their bank accounts. The account name or nickname
            and the last four digits of the account number tell the user which
            of their accounts they are looking at. The mandatory primary balance
            appears as an amount with a label, and an optional secondary balance
            displays an amount and a label with or without a due date. Use an{' '}
            <Link
              className="link"
              to={'/' + data.site + '/components/link/develop'}
            >
              icon link
            </Link>{' '}
            to offer contextual help only if the balance label needs further
            explanation.
          </p>

          <p>
            The select account card is an input field used in forms with the
            functionality of the{' '}
            <Link
              className="link"
              to={'/' + data.site + '/components/select/develop'}
            >
              select
            </Link>{' '}
            component.
          </p>
          <div class="c-notification--inline-warning">
            <div class="c-notification__icon">
              <i class="icon icon--exclamation"></i>
            </div>
            <div class="c-notification__content">
              Using icon links in this pattern may pose an accessibility risk,
              so avoid them whenever possible.
            </div>
          </div>
        </Intro>

        <SectionTitle>States</SectionTitle>
        {/* Yellow bar in empty and active states needs to be grey */}
        <Showcase
          full={true}
          site={data.site}
          title="Empty"
          text="Instead of displaying account information, the empty state uses a title and subtitle to invite the user to make a selection."
        >
          <div class="c-card__border-top">
            <div class="c-drop-down">
              <div class="c-drop-down__field">
                <div class="c-drop-down__content">
                  <div class="u-display--inline-block l-margin-right--large">
                    <div class="c-title-2--normal u-color--primary-base u-type--bold">
                      Select an account
                    </div>
                    <div class="c-text-content-caption--normal">
                      Expand to see a list of available accounts
                    </div>
                  </div>
                </div>
                <button class="c-drop-down__toggle" id="dropDownToggle">
                  <i class="icon icon--arrow-without-tail-down"></i>
                </button>
              </div>
            </div>
          </div>
        </Showcase>

        <Showcase
          full={true}
          site={data.site}
          title="Active"
          text="In the active state, a dropdown presents other account option with their own hover states, represented by a green bar. There is currently no limit on the number of accounts shown in the dropdown. If the options extend of the screen, the dropdown should stop and scroll within."
        >
          <div class="c-card__border-top">
            <div class="c-drop-down">
              <div class="c-drop-down__field">
                <div class="c-drop-down__content">
                  <div class="u-display--inline-block l-margin-right--large">
                    <div class="c-title-2--normal u-color--primary-base u-type--bold">
                      Select an account
                    </div>
                    <div class="c-text-content-caption--normal">
                      Expand to see a list of available accounts
                    </div>
                  </div>
                </div>
                <button class="c-drop-down__toggle" id="dropDownToggle">
                  <i class="icon icon--arrow-without-tail-down"></i>
                </button>
              </div>
              <div class="c-drop-down__menu u-display--block">
                <button class="c-drop-down__menu-item">
                  <span class="c-drop-down__menu-item-main">
                    Account nickname <span class="u-type--xsmall">...1234</span>
                  </span>
                  <span class="c-drop-down__menu-item-alt">$1,000.00</span>
                </button>
                <button class="c-drop-down__menu-item">
                  <span class="c-drop-down__menu-item-main">
                    Account nickname <span class="u-type--xsmall">...5678</span>
                  </span>
                  <span class="c-drop-down__menu-item-alt">$14,000.00</span>
                </button>
                <button class="c-drop-down__menu-item">
                  <span class="c-drop-down__menu-item-main">
                    Account nickname <span class="u-type--xsmall">...9000</span>
                  </span>
                  <span class="c-drop-down__menu-item-alt">$7.83</span>
                </button>
              </div>
            </div>
          </div>
        </Showcase>

        <Showcase
          full={true}
          site={data.site}
          title="Selected"
          text={
            <p>
              The selected state presents all the account and balance
              information of the selected account.
            </p>
          }
        >
          <div class="c-card__border-top u-flex-container u-flex-wrap--wrap">
            <div class="c-card__body--small u-flex-wrap--wrap">
              <div>
                <a href="#" class="c-card__title--actionable">
                  Accoung nickname{' '}
                  <span class="c-card__title-sub">...1234</span>
                </a>
                {/* The above element should not be a link, this is static text */}
              </div>
              <div class="u-display--inline-block l-margin-right--large">
                <div class="c-title-2--normal">
                  <sup class="u-type--small">$</sup>1,000.00
                </div>
                <div class="c-label u-type--xsmall u-display--inline l-margin-bottom--none l-margin-right--xxsmall">
                  Balance Label
                </div>
                <a href="" class="c-icon-link u-type--xsmall u-display--inline">
                  <i class="icon icon--question c-icon-link__icon u-type--xsmall"></i>
                  What's this?
                </a>
              </div>
              <div class="u-display--inline-block">
                <div class="c-title-2--normal">
                  <span class="u-type--medium">$1,000.00</span>{' '}
                  <span class="u-type--xsmall">due on 12/31/20</span>
                </div>
                <div class="c-label u-type--xsmall u-display--inline l-margin-bottom--none l-margin-right--xxsmall">
                  Balance Label
                </div>
                <a href="" class="c-icon-link u-type--xsmall u-display--inline">
                  <i class="icon icon--question c-icon-link__icon u-type--xsmall"></i>
                  What's this?
                </a>
              </div>
            </div>
            <ul class="c-horizontal-list">
              <li class="c-horizontal-list__item">
                <a href="" class="c-horizontal-list__link">
                  <i class="c-horizontal-list__icon icon icon--arrow-without-tail-down" />
                </a>
              </li>
            </ul>
          </div>
        </Showcase>

        <hr />

        <SectionTitle>Error States</SectionTitle>
        <p>
          The card will display various errors when balance information can't be
          recalled.
        </p>
        <Showcase
          full={true}
          site={data.site}
          title="Functional"
          text="Used when some of the information in the account card can't be shown but the associated actions are still functional. Only show errors where the information is missing. The yellow bar will remain yellow in the error state unless using a status bar."
        >
          <div class="c-card__border-top">
            <div class="c-card__body--small l-padding-bottom--none">
              <a href="#" class="c-card__title--actionable">
                Account nickname <span class="c-card__title-sub">...1234</span>
                <i class="c-card__title--actionable-icon icon icon--arrow-without-tail-right"></i>
              </a>
            </div>
            <div class="c-drop-down">
              <div class="c-drop-down__field">
                <div class="c-drop-down__content">
                  <div class="u-display--inline-block l-margin-right--large">
                    <div class="c-title-2--normal">
                      <sup class="u-type--small">$</sup>1,000.00
                    </div>
                    <div class="c-label u-type--xsmall u-display--inline l-margin-bottom--none l-margin-right--xxsmall">
                      Balance Label
                    </div>
                    <a
                      href=""
                      class="c-icon-link u-type--xsmall u-display--inline"
                    >
                      <i class="icon icon--question c-icon-link__icon u-type--xsmall"></i>
                      What's this?
                    </a>
                  </div>
                  <div class="u-display--inline-block">
                    <div class="c-title-2--normal">
                      <span class="u-type--medium">$1,000.00</span>{' '}
                      <span class="u-type--xsmall">due on 12/31/20</span>
                    </div>
                    <div class="c-label u-type--xsmall u-display--inline l-margin-bottom--none l-margin-right--xxsmall">
                      Balance Label
                    </div>
                    <a
                      href=""
                      class="c-icon-link u-type--xsmall u-display--inline"
                    >
                      <i class="icon icon--question c-icon-link__icon u-type--xsmall"></i>
                      What's this?
                    </a>
                  </div>
                </div>
                <button class="c-drop-down__toggle" id="dropDownToggle">
                  <i class="icon icon--arrow-without-tail-down"></i>
                </button>
              </div>
              <div class="c-drop-down__menu" id="dropDownMenu">
                <a href="#" class="c-drop-down__menu-item">
                  <span class="c-drop-down__menu-item-main">
                    Account nickname <span class="u-type--xsmall">...1234</span>
                  </span>
                  <span class="c-drop-down__menu-item-alt">$1,000.00</span>
                </a>

                <a class="c-drop-down__menu-item">
                  <span class="c-drop-down__menu-item-main">
                    Account nickname <span class="u-type--xsmall">...5678</span>
                  </span>
                  <span class="c-drop-down__menu-item-alt">$14,000.00</span>
                </a>

                <a href="#" class="c-drop-down__menu-item">
                  <span class="c-drop-down__menu-item-main">
                    Account nickname <span class="u-type--xsmall">...9000</span>
                  </span>
                  <span class="c-drop-down__menu-item-alt">$7.83</span>
                </a>
              </div>
            </div>
          </div>
        </Showcase>
        <Showcase
          full={true}
          site={data.site}
          title="Non-Functional"
          text="When no information can be shown, or the actions on the card are not functional, the error message will appear without a border."
        >
          <div class="c-card__border-top u-flex-container u-flex-wrap--wrap">
            <div class="c-card__body--small u-flex-wrap--wrap">
              <div class="c-card__body--small l-padding-bottom--none">
                <a href="#" class="c-card__title--actionable">
                  Account nickname{' '}
                  <span class="c-card__title-sub">...1234</span>
                  <i class="c-card__title--actionable-icon icon icon--arrow-without-tail-right"></i>
                </a>
              </div>
              <span class="u-display--inline-block l-margin-right--large">
                <i class="icon icon--error u-color--redbase" />
                <span class="c-text-content-caption--normal">
                  Sorry, but we're having trouble displaying this account right
                  now. Please try again later.
                </span>
              </span>
            </div>
          </div>
        </Showcase>
        {/* Nonfunctional error is account card level error, always looks the same across card patterns, statically built asset is fine. Functional errors are at the state level, apply to active and selected states. Account balances in active state change to unavailable in red and in selected state. Must be built out functionally so users can see the errors in each state. Ryan had something almost there in the sandbox, needs to include the empty state and needs to let the cursors change */}

        <SectionTitle>Design Environment</SectionTitle>
        <p>
          The selected and active states will appear slightly different at
          smaller breakpoints.
        </p>
        <Showcase
          site={data.site}
          title="Stacked"
          text="Used when space is limited and the balance information won't fit side by side with the down arrow icon. Help links may use the icon only variation at this width."
        ></Showcase>
        <Showcase
          site={data.site}
          title="Active"
          text="To optimize touch interactions at smaller breakpoints, account options are listed in a full-screen modal as populated cards instead of in a dropdown. Selecting a card within the list will exit the modal and bring the user back to the initial screen."
        ></Showcase>
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          The empty state text is predefined and may not be changed. Balance
          labels should stay on a single line of text. Otherwise, follow the
          microcopy guidelines for the{' '}
          <Link
            className="link"
            to={'/' + data.site + '/components/link/develop'}
          >
            link
          </Link>{' '}
          and{' '}
          <Link
            className="link"
            to={'/' + data.site + '/components/link/develop'}
          >
            label
          </Link>{' '}
          components.
        </p>
      </Layout>
    </>
  )
}
